import Icon from './Microscope.svg';
export default function Microscope(){
  return <img style={{height:16}} src={Icon}/>
}
